<vb-ui-progress-bar *ngIf="isProcessing && !processingCompleteTimeout && !isProcessingFailed" [ngClass]="styles.progressBar" [label]="'Processing' | translate" [max]="1" [mini]="true" [progress]="overallProgress">
</vb-ui-progress-bar>

<span [ngClass]="styles.processingComplete" *ngIf="processingCompleteTimeout && !isProcessingFailed">
	{{ 'Media_Videos_Replace_CompleteMessage' | translate }}
</span>

<span [ngClass]="styles.processingErrorMessage" *ngIf="isProcessingFailed">
	<span class="glyphicons warning_sign"></span>
	{{ 'Video_Playback_VideoProcessingFailedShort' | translate }}
</span>
